module.exports = __webpack_public_path__ + "static/images/3_rainy_taxi_night.d914ff13.jpg";